// Wait for ModalDialog to be available before defining quickshop-modal
function initQuickshopModal() {
  if (!customElements.get('quickshop-modal')) {
    customElements.define('quickshop-modal', class QuickshopModal extends ModalDialog {
      constructor() {
        super();
        this.modalContent = this.querySelector('[id^="QuickshopInfo-"]');
      }

    hide(preventFocus = false) {
      const cartNotification = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
      if (cartNotification) cartNotification.setActiveElement(this.openedBy);
      this.modalContent.innerHTML = '';
      
      // Clear footer as well
      const footer = this.querySelector('.quickshop-modal__footer_inner');
      if (footer) footer.innerHTML = '';

      if (preventFocus) this.openedBy = null;
      super.hide();
    }

    show(opener) {
      opener.setAttribute('aria-disabled', true);
      opener.classList.add('loading');
      
      const spinner = opener.querySelector('.loading-overlay__spinner');
      if (spinner) spinner.classList.remove('hidden');

      // Get product handle from the opener button
      const productHandle = opener.getAttribute('data-product-handle');
      const productUrl = opener.getAttribute('data-product-url');

      // Build the URL properly - use & if there are already query params, otherwise use ?
      const separator = productUrl.includes('?') ? '&' : '?';
      const fetchUrl = `${productUrl}${separator}section_id=quickshop-product`;

      // Fetch the rendered quickshop section using Shopify's Section Rendering API
      fetch(fetchUrl)
        .then((response) => response.text())
        .then((responseText) => {
          const responseHTML = new DOMParser().parseFromString(responseText, 'text/html');
          const quickshopProduct = responseHTML.querySelector('.quickshop-product');
          
          if (quickshopProduct) {
            this.setInnerHTML(this.modalContent, quickshopProduct.outerHTML);
            this.preventVariantURLSwitching();
            this.initializeVariantPicker();
            this.moveAddToCartToFooter();
            
            // Initialize Shopify Payment Button if available
            if (window.Shopify && Shopify.PaymentButton) {
              Shopify.PaymentButton.init();
            }
            
            super.show(opener);
          }
        })
        .catch((error) => {
          console.error('Error loading quickshop:', error);
        })
        .finally(() => {
          opener.removeAttribute('aria-disabled');
          opener.classList.remove('loading');
          if (spinner) spinner.classList.add('hidden');
        });
    }

    setInnerHTML(element, html) {
      element.innerHTML = html;

      // Reinjects the script tags to allow execution
      // By default, scripts are disabled when using element.innerHTML
      element.querySelectorAll('script').forEach(oldScriptTag => {
        const newScriptTag = document.createElement('script');
        Array.from(oldScriptTag.attributes).forEach(attribute => {
          newScriptTag.setAttribute(attribute.name, attribute.value)
        });
        newScriptTag.appendChild(document.createTextNode(oldScriptTag.innerHTML));
        oldScriptTag.parentNode.replaceChild(newScriptTag, oldScriptTag);
      });
    }

    preventVariantURLSwitching() {
      const variantPicker = this.modalContent.querySelector('variant-radios,variant-selects');
      if (!variantPicker) return;

      variantPicker.setAttribute('data-update-url', 'false');
    }

    moveAddToCartToFooter() {
      const footer = this.querySelector('.quickshop-modal__footer_inner');
      
      if (!footer) return;
      
      // The content is injected into modalContent, so search there
      const quantitySection = this.modalContent.querySelector('.quickshop-product__quantity');
      const submitSection = this.modalContent.querySelector('.quickshop-product__submit');
      
      if (quantitySection && submitSection) {
        // Move both to footer
        footer.appendChild(quantitySection);
        footer.appendChild(submitSection);
      }
    }

    initializeVariantPicker() {
      const variantRadios = this.modalContent.querySelector('variant-radios');
      if (!variantRadios) return;

      // Get the product form and variant data
      const form = variantRadios.querySelector('form') || this.modalContent.querySelector('form');
      const variantDataScript = variantRadios.querySelector('script[type="application/json"]');
      if (!variantDataScript) return;
      
      const variantData = JSON.parse(variantDataScript.textContent);
      
      if (!form || !variantData) return;

      // Listen for variant option changes on both inputs AND labels
      const variantInputs = variantRadios.querySelectorAll('input[type="radio"]');
      const variantLabels = variantRadios.querySelectorAll('label.pill, label.swatch');
      
      variantInputs.forEach(input => {
        input.addEventListener('change', () => {
          this.updateVariant(variantRadios, form, variantData);
        });
        
        // Also add click listener
        input.addEventListener('click', () => {
          this.updateVariant(variantRadios, form, variantData);
        });
      });
      
      // Add click listeners to labels too as backup
      variantLabels.forEach(label => {
        label.addEventListener('click', (e) => {
          setTimeout(() => {
            this.updateVariant(variantRadios, form, variantData);
          }, 50);
        });
      });

      // Initialize with current selection
      this.updateVariant(variantRadios, form, variantData);

      // Handle form submission
      this.setupFormSubmission(form);
    }

    updateVariant(variantRadios, form, variantData) {
      // Get currently selected options in order
      const selectedOptions = [];
      const fieldsets = variantRadios.querySelectorAll('fieldset.product-form__input');
      
      fieldsets.forEach(fieldset => {
        const checkedInput = fieldset.querySelector('input[type="radio"]:checked');
        if (checkedInput) {
          selectedOptions.push(checkedInput.value);
        }
      });

      // Find matching variant based on option positions
      const selectedVariant = variantData.find(variant => {
        let matches = true;
        
        selectedOptions.forEach((optionValue, index) => {
          const variantOption = variant[`option${index + 1}`];
          if (variantOption !== optionValue) {
            matches = false;
          }
        });
        
        return matches;
      });

      if (selectedVariant) {
        // Update hidden variant ID input
        const variantInput = form.querySelector('input[name="id"]');
        if (variantInput) {
          variantInput.value = selectedVariant.id;
          
          // Dispatch event for cart drawer/notification
          variantInput.dispatchEvent(new Event('change', { bubbles: true }));
        }

        // Update price display
        this.updatePrice(selectedVariant);

        // Update add to cart button - it might be in footer now
        const addButton = form.querySelector('button[name="add"]') || 
                         this.querySelector('.quickshop-modal__footer_inner button[name="add"]');
        if (addButton) {
          if (selectedVariant.available) {
            addButton.disabled = false;
            addButton.querySelector('span').textContent = 'Add To Bag';
          } else {
            addButton.disabled = true;
            addButton.querySelector('span').textContent = 'Sold Out';
          }
        }
      }
    }

    updatePrice(variant) {
      const priceContainer = this.modalContent.querySelector('.quickshop-product__price .price');
      if (!priceContainer) return;

      const price = variant.price;
      const compareAtPrice = variant.compare_at_price;

      if (compareAtPrice && compareAtPrice > price) {
        priceContainer.innerHTML = `
          <span class="price-item price-item--sale text-red-600">
            ${this.formatMoney(price)}
          </span>
          <s class="price-item price-item--regular text-black-400 ml-2">
            ${this.formatMoney(compareAtPrice)}
          </s>
        `;
      } else {
        priceContainer.innerHTML = `
          <span class="price-item">
            ${this.formatMoney(price)}
          </span>
        `;
      }
    }

    formatMoney(cents) {
      // Use Shopify's money format if available
      if (window.Shopify && window.Shopify.formatMoney) {
        return window.Shopify.formatMoney(cents, window.theme.moneyFormat || '${{amount}}');
      }
      // Fallback to simple format
      return '$' + (cents / 100).toFixed(2);
    }

    setupFormSubmission(form) {
      // Find submit button - it might be in the footer now
      const submitButton = this.modalContent.querySelector('button[name="add"]') || 
                          this.querySelector('.quickshop-modal__footer_inner button[name="add"]');
      
      if (!submitButton) return;
      
      const formData = new FormData(form);
      
      submitButton.addEventListener('click', (e) => {
        e.preventDefault();
        
        // Get cart drawer/notification
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        
        // Rebuild formData on each click to get current values
        const currentFormData = new FormData(form);
        
        // Append sections to render (like product-form.js does)
        if (this.cart) {
          const sectionsToRender = this.cart.getSectionsToRender().map((section) => section.id);
          currentFormData.append('sections', sectionsToRender);
          currentFormData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        
        // Show loading state
        submitButton.setAttribute('aria-disabled', true);
        submitButton.classList.add('loading');
        const buttonText = submitButton.querySelector('span');
        const originalText = buttonText.textContent;
        buttonText.textContent = 'Adding...';
        
        const config = {
          method: 'POST',
          headers: {
            'X-Requested-With': 'XMLHttpRequest',
            'Accept': 'application/json'
          },
          body: currentFormData
        };
        
        // Add to cart via AJAX - use /cart/add (not .js) to get sections back
        fetch('/cart/add', config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              // Handle error
              const errorMessage = form.querySelector('.product-form__error-message-wrapper');
              if (errorMessage) {
                errorMessage.querySelector('.product-form__error-message').textContent = response.description || 'There was an error adding this item to your cart.';
                errorMessage.removeAttribute('hidden');
                
                setTimeout(() => {
                  errorMessage.setAttribute('hidden', '');
                }, 3000);
              }
              return;
            }
            
            // Update and open cart drawer FIRST (like product-form.js does)
            if (this.cart) {
              this.cart.renderContents(response);
            }
            
            // THEN close quickshop modal after a small delay
            setTimeout(() => {
              this.hide();
            }, 100);
          })
          .catch(error => {
            console.error('Error adding to cart:', error);
            
            // Show error message
            const errorMessage = form.querySelector('.product-form__error-message-wrapper');
            if (errorMessage) {
              errorMessage.querySelector('.product-form__error-message').textContent = 'There was an error adding this item to your cart. Please try again.';
              errorMessage.removeAttribute('hidden');
              
              setTimeout(() => {
                errorMessage.setAttribute('hidden', '');
              }, 3000);
            }
          })
          .finally(() => {
            // Reset button state
            submitButton.removeAttribute('aria-disabled');
            submitButton.classList.remove('loading');
            buttonText.textContent = originalText;
          });
      });
    }

  });
  }
}

// Initialize when ModalDialog is available
if (typeof ModalDialog !== 'undefined') {
  // ModalDialog already loaded
  initQuickshopModal();
  initQuickshopButtons();
} else {
  // Wait for DOMContentLoaded to ensure all scripts are loaded
  document.addEventListener('DOMContentLoaded', function() {
    if (typeof ModalDialog !== 'undefined') {
      initQuickshopModal();
      initQuickshopButtons();
    } else {
      console.error('ModalDialog not found. Make sure global.js or details-modal.js is loaded before quickshop-modal.js');
    }
  });
}

// Initialize quickshop button handlers with event delegation
function initQuickshopButtons() {
  // Use event delegation on document body to catch dynamically added buttons
  document.body.addEventListener('click', function(e) {
    // Check if the clicked element or its parent is a quickshop button
    const button = e.target.closest('.quickshop-button, [data-quickshop-button], button[data-product-handle]');
    
    if (button) {
      // Clear any stuck loading states
      if (button.getAttribute('aria-disabled') === 'true' || button.classList.contains('loading')) {
        button.removeAttribute('aria-disabled');
        button.classList.remove('loading');
        const spinner = button.querySelector('.loading-overlay__spinner');
        if (spinner) spinner.classList.add('hidden');
      }
      
      // Prevent default and stop propagation to prevent inline onclick from firing
      e.preventDefault();
      e.stopPropagation();
      
      // Get the quickshop modal
      const modal = document.querySelector('quickshop-modal');
      
      if (modal && typeof modal.show === 'function') {
        modal.show(button);
      }
      
      return false; // Extra safety to prevent inline handlers
    }
  }, true); // Use capture phase to intercept before inline handlers
}